import * as React from 'react';

import { Title } from 'common/components';
import { Glossary, PlanListGL } from 'common/utils/glossary';

const MESSAGE_TYPES = {
  notFoundAnyPlan: PlanListGL.NotFoundAnyPlan,
  notSelectedCountry: PlanListGL.NotSelectedCountry,
  otherError: PlanListGL.OtherError
} as const;
export type MESSAGE_TYPES_KEY = keyof typeof MESSAGE_TYPES;

interface Props {
  /** メッセージを表示するか否か */
  show: boolean;
  /** メッセージの種類 */
  messageType?: MESSAGE_TYPES_KEY;
  /** グロッサリ */
  glossary: Glossary;
}

/**
 * プランリストに表示するエラーメッセージのPresentation Component
 */
export const PlanListMessage: React.FC<Props> = ({
  show,
  messageType,
  glossary
}) => {
  const messageText = messageType && glossary.glx(MESSAGE_TYPES[messageType]);
  // 表示するComponentをメモライズ
  const _message = React.useMemo(() => {
    return show && messageType ? (
      <Title
        type="listMessage"
        data-test={`${messageType}-message`}
        className="plan-listMessage"
      >
        {messageText}
      </Title>
    ) : null;
  }, [show, messageType, messageText]);

  return _message;
};
